import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const popupDVCFileDetail = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/DVCFileDetail.vue'));

const popupChooseVoucherDvcFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/ChooseVoucherDvcFilePopup.vue'),
);

const popupChooseAttachFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/ChooseAttachFilePopup.vue'),
);
// màn hiển thị danh sách CT đã hạch toán (NV rút tiền mặt)
const popupChooseAccountingVoucher = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/DvcChooseAccountingVoucherPopup.vue'),
);

const popupGenerateVoucherAuto = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/generateVoucherAuto/GenerateVoucherAuto.vue'),
);
const popupDvcReject = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/popup/DvcRejectPopup.vue'));
const popupChooseFileReceiver = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/FileReceivePopup.vue'),
);
const popupDvcChooseReport = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/DVCChooseReportPopup.vue'),
);
const popupDvcIntrodution = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/IntroductionDvcPopup.vue'),
);

const popupStandardizeDvcBudgetSource = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/StandardizeDvcBudgetSource.vue'),
);

const popupDVCMappingCommercialBank = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/DVCMappingCommercialBank.vue'),
);

const popupChooseFileInformation = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/AttachFileInformationPopup.vue'),
);

const popupDCSDReportTemplate = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/dcsdReportTemplate/DCSDReportTemplate.vue'),
);

const popupViewVoucher = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/popup/DVCVoucher.vue'));

const popupSettingDVCFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/SettingDVCFilePopup.vue'),
);

const popupDCSDFileDetail = defineAsyncComponent(() => import('@/views/etreasury/DCSDFile/DCSDFileDetail.vue'));

const popupSettingDCSDFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/popup/SettingDCSDFilePopup.vue'),
);

const popupReportParam_DCSD_N01a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N01a_SDKP_DVDT_ND112020/ReportParamPopup.vue'),
);

const popupReportParam_DCSD_N02a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N02a_SDKP_DVDT_ND112020/ReportParamPopup.vue'),
);

const popupReportCompare_DCSD_N02a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N02a_SDKP_DVDT_ND112020/ReportCompareTemplate.vue'),
);

const popupReportParam_DCSD_N04a_SDKP_DVDT_ND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N04a_SDKP_DVDT_ND112020/ReportParamPopup.vue'),
);

const popupReportParam_DCSD_06_DCSDTK_KBNN = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_06_DCSDTK_KBNN/ReportParamPopup.vue'),
);
const popupDVCTreasuryCashWithdraw = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/transactionrecordDVC/DVCTreasuryCashWithdraw.vue'),
);

const popupChooseVoucherPosted = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/DvcChooVoucherPosted.vue'),
);
const popupDVCAdvancePayment = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/transactionrecordDVC/DvcAdvancePayment.vue'),
);

const popupDvcInvestmentAdvance = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/transactionrecordDVC/DvcInvestmentAdvance.vue'),
);

const popupETreasuryProcess = defineAsyncComponent(() => import('@/views/etreasury/process/EtreasuryProcessTab.vue'));
const dvcVideoPopup = defineAsyncComponent(() => import('@/views/etreasury/process/DvcVideoPopup.vue'));

const dvcFileTab = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/DVCFileList.vue'));
const dcsdFileTab = defineAsyncComponent(() => import('@/views/etreasury/DCSDFile/DCSDFileList.vue'));

const popupC202aNSND112020_WithBankAccount = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C202NS_ND112020_WithBankAccount/C202aNSND112020_WithBankAccount.vue'),
);

const popupC202bNSND112020_WithBankAccount = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C202NS_ND112020_WithBankAccount/C202bNSND112020_WithBankAccount.vue'),
);
const popupC301NSND112020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/c301NS_ND112020/C301NS_ND112020.vue'),
);

const popupReportParam04aTT = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/report04aTT/Report04aTT.vue'),
);

// C3-02-NS
const popupReportParamC302NSND112020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/c302NS_ND112020/ReportParamC302NSND112020.vue'),
);

const popupC402aKBND112020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C402aKB_ND112020/C402aKB_ND112020.vue'),
);
const popupC205aNSND112020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/c205a_ND112020/C205a_ND112020.vue'),
);
const popupC402cKBND112020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C402cKB_ND112020/C402cKB_ND112020.vue'),
);

const popupC102NSTT842016 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/c102ns_TT842016/c102NS_TT842016.vue'),
);
const popupReportParamC102NS = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/report_c102_ns/ReportParamC102NS.vue'),
);
//#region
const popupDVCC202aNSND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/dvcReport/DVCC202aNSND112020/DVCC202aNSND112020.vue'),
);
const popupDvcC203ND112020 = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/dvcReport/DVCC203ND112020/DvcC203ND112020.vue'),
);

const popupVoucherDvcFile = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/popup/DVCVoucherFile.vue'));

const popupDigitalSignatureConfirmationForm = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcSign/DigitalSignatureConfirmationForm.vue'),
);
const popupDvcInvestmentDetail = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/transactionrecordDVC/DvcInvestmentDetail.vue'),
);

const popupDVCC402 = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/dvcReport/DVCC402/DVCC402.vue'),
);

const dvcTransferUnit = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/DvcTransferUnit.vue'));

const popupDVC05TT = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/dvcReport/DVC05TT/DVC05TT.vue'),
);

const popupDVC04aTT = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/dvcReport/DVC04aTT/DVC04aTT.vue'),
);

const dvcBudgetDetail = defineAsyncComponent(() => import('@/views/etreasury/process/DvcBudgetDetail.vue'));
const dvcVoucherNotGenerate = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/GenerateFileKbnnApprove/VoucherNotGenerate.vue'),
);
const dvcChooseVoucherGenerate = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/GenerateFileKbnnApprove/ChooseVoucherGenerate.vue'),
);

const popupDvcAccountingVoucherMapping = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/DvcAccountingVoucherMapping.vue'),
);
const popupDcsdChooseTemplateReport = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/popup/DcsdChooseTemplateReport.vue'),
);

//#region Hồ sơ đối chiếu
const popupDCSDReportTemplate01a = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N01a_SDKP_DVDT_ND112020/DcsdReportTemplate01a.vue'),
);

const popupDCSDReportTemplate06 = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_06_DCSDTK_KBNN/DcsdReportTemplate06.vue'),
);
//#endregion

const popupDCSDReportTemplate04a = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N04a_SDKP_DVDT_ND112020/DcsdReportTemplate04a.vue'),
);

const popupDCSDMappingBudgetSource = defineAsyncComponent(() =>
  import('@/views/etreasury/DCSDFile/reportParam/DCSD_N04a_SDKP_DVDT_ND112020/DCSDMappingBudgetSource.vue'),
);

//#endregion

// popup hiển thị kết quả sinh HT, sinh CT lương bảo hiểm
const popupResultGenerateAccounting = defineAsyncComponent(() =>
  import('@/views/etreasury/DVCFile/popup/PopupResultGenerateAccounting.vue'),
);
const popupReport04aTTND2020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/report04aTT/Report04aTTND2020.vue'),
);

export function registerETreasury(app) {
  const registerConfig = {
    DvcChooseReportPopup: popupDvcChooseReport,
    DVCFileDetail: popupDVCFileDetail,
    ChooseVoucherDvcFilePopup: popupChooseVoucherDvcFilePopup, // Màn hình thêm mẫu chứng từ giao dịch với KBNN
    ChooseAttachFilePopup: popupChooseAttachFilePopup, // Màn hình thêm mẫu chứng từ giao dịch với KBNN
    DvcRejectPopup: popupDvcReject, // Màn hình nhập lí do từ chối duyệt hồ sơ
    GenerateVoucherAuto: popupGenerateVoucherAuto, // Màn hình hiển thị danh sách tự động sinh chứng từu bảo hiểm

    ViewVoucherPopup: popupViewVoucher, // màn hình xem chứng từ
    SettingDVCFilePopup: popupSettingDVCFilePopup, // Màn hình thêm mẫu chứng từ giao dịch với KBNN

    DCSDFileDetail: popupDCSDFileDetail, // Màn hình chi tiết hồ sơ đối chiếu số dư
    SettingDCSDFilePopup: popupSettingDCSDFilePopup, // Màn hình thêm mẫu chứng từ giao dịch với KBNN

    //#region Tham số báo cáo hồ sơ đối chiếu số dư
    ReportParamDCSDN01aSDKPDVDTND112020: popupReportParam_DCSD_N01a_SDKP_DVDT_ND112020,
    ReportParamDCSDN02aSDKPDVDTND112020: popupReportParam_DCSD_N02a_SDKP_DVDT_ND112020,
    ReportParamDCSDN04aSDKPDVDTND112020: popupReportParam_DCSD_N04a_SDKP_DVDT_ND112020,
    ReportParamDCSD06DCSDTKKBNN: popupReportParam_DCSD_06_DCSDTK_KBNN,
    //#endregion

    ReportCompareDCSDN02aSDKPDVDTND112020: popupReportCompare_DCSD_N02a_SDKP_DVDT_ND112020,
    DVCTreasuryCashWithdraw: popupDVCTreasuryCashWithdraw,
    ChooseFileInformationPopup: popupChooseFileInformation,
    ChooseFileReceiverPopup: popupChooseFileReceiver,
    DCSDReportTemplate: popupDCSDReportTemplate,
    DVCAdvancePayment: popupDVCAdvancePayment,
    DVCInvestmentAdvance: popupDvcInvestmentAdvance,
    ChooseVoucherPosted: popupChooseVoucherPosted,
    EtreasuryProcess: popupETreasuryProcess,
    DVCFileTab: dvcFileTab,
    DCSDFileTab: dcsdFileTab,

    C202aNSND112020WithBankAccount: popupC202aNSND112020_WithBankAccount,

    C202bNSND112020WithBankAccount: popupC202bNSND112020_WithBankAccount,
    C301NSND112020: popupC301NSND112020,
    Report04aTT: popupReportParam04aTT,
    ReportParamC302NSND112020: popupReportParamC302NSND112020,
    C402aKBND112020: popupC402aKBND112020,
    C402cKBND112020: popupC402cKBND112020,
    C205a_ND112020: popupC205aNSND112020,
    C102ns_tt842016: popupC102NSTT842016,
    ReportParamC102NS: popupReportParamC102NS,
    //#region Form tham số
    DVCC202aNSND112020: popupDVCC202aNSND112020,
    DvcC203ND112020: popupDvcC203ND112020,
    //#endregion
    // popup hiển thị chứng từ đã sinh HT
    DvcVoucherFilePopup: popupVoucherDvcFile,
    // popup hướng dẫn
    DvcIntroductionPopup: popupDvcIntrodution,
    StandardizeDvcBudgetSourcePopup: popupStandardizeDvcBudgetSource,

    //Màn cf ký eSign
    DigitalSignatureConfirmationForm: popupDigitalSignatureConfirmationForm,
    DvcVideoPopup: dvcVideoPopup,
    DvcInvestmentDetail: popupDvcInvestmentDetail,
    DVCC402: popupDVCC402,
    DvcTransferUnit: dvcTransferUnit,
    DVC05TT: popupDVC05TT,
    DVC04aTT: popupDVC04aTT,
    DvcBudgetDetail: dvcBudgetDetail,
    DvcVoucherNotGenerate: dvcVoucherNotGenerate,
    DvcChooseVoucherGenerate: dvcChooseVoucherGenerate,
    DVCMappingCommercialBank: popupDVCMappingCommercialBank,
    DvcAccountingVoucherMapping: popupDvcAccountingVoucherMapping,
    DcsdChooseTemplateReport: popupDcsdChooseTemplateReport,

    //#region Hồ sơ đối chiếu số dư
    DcsdReport01a: popupDCSDReportTemplate01a,
    DcsdReport06: popupDCSDReportTemplate06,
    //#endregion
    DcsdReport04a: popupDCSDReportTemplate04a,
    DCSDMappingBudgetSource: popupDCSDMappingBudgetSource,
    DcsdReport06: popupDCSDReportTemplate06,
    //#endregion
    ChooseAccountingVoucherPopup: popupChooseAccountingVoucher, // popup chọn chứng từ đã hạch toán
    ResultGenerateAccounting: popupResultGenerateAccounting,
    Report04aTTND2020: popupReport04aTTND2020,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'ETreasury');
}
